/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_No_RolesInputs */

const en_admin_roles_no_roles = /** @type {(inputs: Admin_Roles_No_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No roles defined yet`)
};

/**
* | output |
* | --- |
* | "No roles defined yet" |
*
* @param {Admin_Roles_No_RolesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_no_roles = /** @type {((inputs?: Admin_Roles_No_RolesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_No_RolesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_no_roles(inputs)
});
export { admin_roles_no_roles as "admin.roles.no_roles" }